export default __webpack_public_path__ + "static/media/plain-sticker-J.9c55e975.png";